import sharedRouteNames from "@/shared/router/routeNames";

export default {
  ...sharedRouteNames,
  ssoLogin: "sso-login",
};
